
import { useContext } from "react";
import DashboardHeader from "./DashboardHeader";
import LoginContext from "../LoginContext";
import DailyAssignments from "./DailyAssignments";
import UserTestStats from "./UserTestStats";

export default function Dashboard() {
  const { userName }: any = useContext(LoginContext);


  return (
    <div className="min-h-screen bg-base-200">
      <DashboardHeader />
      <main className="p-4 md:p-8 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Welcome back, {userName}!</h2>

        {/* Component 2: Stats */}
        <UserTestStats />

        {/* Component 3: To-Do List */}
        <div className="mt-8">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold">Your Assignments</h3>
          </div>
          <DailyAssignments />
        </div>
      </main>
    </div>
  );
}

